<template>
  <div class="v-data-footer">
    <v-row class="footer-row">
      <div class="v-data-footer__select col-auto">
        <div id="pages-per-count"> {{ $t("page_count_string") }} </div>

        <v-select
          v-model="select"
          :items="getOptions"
          :value="getSelected"
          persistent-hint
          single-line
          @change="handleOnChangeOptions"
          :disabled="isLoading"
          class="drop-down-list"
          hide-details
        />
      </div>
      <v-col class="air-table-pagination col-auto">
        <template v-if="!isRtl">
          <div class="v-data-footer__pagination">{{ pageStart }}-{{ pageStop }} {{ $t("of") }} {{ totalRows }}</div>
          <div class="v-data-footer__icons-before">
            <v-btn @click="handleOnMovePrev" icon text :disabled="getPage <= 1 || loading">
              <v-icon disabled>mdi-chevron-left</v-icon>
            </v-btn>
          </div>
          <div class="v-data-footer__icons-after">
            <v-btn @click="handleOnMoveNext" icon text :disabled="pageStop >= totalRows || loading">
              <v-icon disabled>mdi-chevron-right</v-icon>
            </v-btn>
          </div>
        </template>

        <template v-else>
          <div class="v-data-footer__pagination">{{ pageStart }}-{{ pageStop }} {{ $t("of") }} {{ totalRows }}</div>
          <div class="v-data-footer__icons-after">
            <v-btn @click="handleOnMovePrev" icon text :disabled="getPage <= 1 || loading">
              <v-icon disabled>mdi-chevron-right</v-icon>
            </v-btn>
          </div>
          <div class="v-data-footer__icons-before">
            <v-btn @click="handleOnMoveNext" icon text :disabled="pageStop >= totalRows || loading">
              <v-icon disabled>mdi-chevron-left</v-icon>
            </v-btn>
          </div>
        </template>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "AirTableFooter",
  props: {
    itemsPerPageOptions: {},
    options: {},
    pagination: {},
    handleUpdateTableData: {},
    totalRows: {},
    loading: { type: Boolean },
  },

  data() {
    return {
      select: 10,
      pageStart: 0,
      pageStop: 0,
      total: 1000,
      isLoading: true,
      page: 1,
    };
  },

  computed: {
    ...mapGetters({
      isRtl: "App/isRtl",
    }),

    getOptions() {
      return this.itemsPerPageOptions; //.filter((item) => item <= this.totalRows);
    },

    getSelected() {
      return this.itemsPerPageOptions;
    },

    getPage() {
      return this.page || 1;
    },
  },

  mounted() {
    this.isLoading = false;
    this.select = this.options.itemsPerPage;
    this.pageStop = this.options.itemsPerPage;
  },

  watch: {
    options: {
      immediate: true,
      deep: true,

      handler(value) {
        if (!value) {
          return;
        }
        this.pageStart = (this.page - 1) * value.itemsPerPage + 1;
        this.pageStop = this.page * value.itemsPerPage;
        if (this.pageStop >= this.totalRows) {
          this.pageStop = this.totalRows;
        }
      },
    },
    isRtl: {
      immediate: true,
      deep: true,

      handler(value) {},
    },
  },

  methods: {
    /**
     * handle on change the page options
     * @param itemsPerPage
     * @return {Promise<void>}
     */
    async handleOnChangeOptions(itemsPerPage) {
      this.isLoading = true;
      this.options.itemsPerPage = itemsPerPage;
      this.page = 1;
      this.handleUpdateTableData({ ...this.options, page: 1 });
      this.isLoading = false;
    },

    /**
     * Handle on next page
     * @param e
     */
    handleOnMoveNext(e) {
      e.preventDefault();
      this.isLoading = true;

      this.options.page = ++this.page;
      this.handleUpdateTableData({ ...this.options });
      this.isLoading = false;
      this.$forceUpdate();
    },

    /**
     * Handle on prev page
     * @param e
     */
    handleOnMovePrev(e) {
      e.preventDefault();
      this.isLoading = true;

      this.options.page = --this.page;
      this.handleUpdateTableData({ ...this.options });
      this.isLoading = false;
      this.$forceUpdate();
    },
  },
};
</script>
